export default class SVGMatrixParam {
  public scaleX: number;

  public scaleY: number;

  public x: number;

  public y: number;
}
